"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.truncateDecimal = void 0;
const truncateDecimal = (value, numDecimals = 2) => {
    if (value === undefined || value === null) {
        return;
    }
    const decimalRegex = new RegExp(`(\\d+\\.\\d{${numDecimals}})(\\d)`);
    const matched = value.toString().match(decimalRegex);
    return matched ? parseFloat(matched[1]) : value.valueOf();
};
exports.truncateDecimal = truncateDecimal;
//# sourceMappingURL=truncateDecimal.js.map